import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/* data import */
import { doctorData, doctorImages } from "../data/doctorData";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* img imports */
import aboutDocBoard from "../assets/images/about-doc-board.png";
import innerPageFlowers from "../assets/images/inner-page-flowers.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";

/* comp imports */
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";

import DoctorInfoModal from "../components/modals/DoctorInfoModal";
import DoctorsThumbsWrapper from "../components/DoctorsThumbsWrapper";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const Doctors = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };

  const [activeDoctorData, setActiveDoctorData] = useState({});

  const handleDoctorInfoClick = (value) => {
    let tempDoctorItemData = doctorData.find((item) => item.id === value);

    if (Object.keys(tempDoctorItemData).length > 0) {
      setActiveDoctorData(tempDoctorItemData);
    }

    const modalElement = document.getElementById("doctorInfoModal");
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper doctors-page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/" />
        <DoctorsThumbsWrapper handleDoctorInfoClick={handleDoctorInfoClick} />
        <div className="doctor-info-board">
          <img src={aboutDocBoard} alt="" />
        </div>
        <div className="inner-page-flower-wrapper">
          <img src={innerPageFlowers} alt="" />
        </div>
      </div>
      <DoctorInfoModal
        activeDoctorData={activeDoctorData}
        doctorImages={doctorImages}
      />
      <MainDisclaimerModal />
    </>
  );
};

export default Doctors;
